import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useKeycloak } from "@/auth/KeycloakAuthState.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { Typography } from "@/uiKit/atoms/Typography.tsx";

export const ImpersonatingBanner = () => {
  const impersonating = useKeycloak(state => state.impersonating);
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);

  if (!impersonating) {
    return null;
  }

  return (
    <div className={styles.banner}>
      <Typography>{t("impersonationWarning")}</Typography>
    </div>
  );
};
const makeStyles = (theme: Theme) => ({
  banner: css`
    background-color: ${theme.palette.error.main};
    display: flex;
    justify-content: space-around;
    align-items: center;
    text-align: center;
    width: 100%;
    position: fixed;
    bottom: 0;
    z-index: 1200;
    padding: ${theme.spacing(5)};
  `,
});
